/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { EntityOrigin } from './EntityOrigin';
import {
    EntityOriginFromJSON,
    EntityOriginFromJSONTyped,
    EntityOriginToJSON,
} from './EntityOrigin';

/**
 * 
 * @export
 * @interface EnumerationOptionDto
 */
export interface EnumerationOptionDto {
    /**
     * 
     * @type {number}
     * @memberof EnumerationOptionDto
     */
    id: number | null;
    /**
     * 
     * @type {string}
     * @memberof EnumerationOptionDto
     */
    name?: string | null;
    /**
     * 
     * @type {EntityOrigin}
     * @memberof EnumerationOptionDto
     */
    origin?: EntityOrigin;
    /**
     * 
     * @type {string}
     * @memberof EnumerationOptionDto
     */
    $type?: EnumerationOptionDtoTypeEnum;
}


/**
 * @export
 */
export const EnumerationOptionDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedDataTypeManagementDtoEnumerationDtoEnumerationOptionDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.DataTypeManagement.Dto.EnumerationDto.EnumerationOptionDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type EnumerationOptionDtoTypeEnum = typeof EnumerationOptionDtoTypeEnum[keyof typeof EnumerationOptionDtoTypeEnum];


/**
 * Check if a given object implements the EnumerationOptionDto interface.
 */
export function instanceOfEnumerationOptionDto(value?: unknown): value is EnumerationOptionDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(EnumerationOptionDtoTypeEnum)[0];
}

export function EnumerationOptionDtoFromJSON(json: any): EnumerationOptionDto {
    return EnumerationOptionDtoFromJSONTyped(json, false);
}

export function EnumerationOptionDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): EnumerationOptionDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'origin': !exists(json, 'origin') ? undefined : EntityOriginFromJSON(json['origin']),
        '$type': !exists(json, '$type') ? undefined : json['$type'],
    };
}

export function EnumerationOptionDtoToJSON(value?: EnumerationOptionDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'id': value.id,
        'name': value.name,
        'origin': EntityOriginToJSON(value.origin),
        '$type': value.$type,
    });
}

